import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { pageColors } from "../mock";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { ArrowLeft, ShoppingBag, Check, Gift } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const SIZES = ["S", "M", "L", "XL", "XXL"];
const PRICE = 80;

const TheShirt = () => {
  const navigate = useNavigate();
  const { addItem } = useCart();
  const { current, token } = useAuth();
  const [size, setSize] = useState("M");
  const [added, setAdded] = useState(false);
  const [claim, setClaim] = useState({ status: "idle", msg: "" });

  useEffect(() => { document.title = "TMM|THE SHIRT"; }, []);

  const isMember = current && current.status === "approved";

  const addToCart = () => {
    addItem({
      id: `shirt-tee-${size.toLowerCase()}`,
      name: `THE SHIRT — size ${size}`,
      price: PRICE,
      image: "/img/theshirt_front.jpeg",
      description: "The Monde Mania — THE SHIRT.",
      tag: "tmm",
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  const claimFree = async () => {
    setClaim({ status: "loading", msg: "" });
    try {
      const res = await fetch(`${API}/api/payments/shirt/claim`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ size: size.toLowerCase() }),
      });
      const data = await res.json();
      if (res.ok) {
        setClaim({ status: "ok", msg: `Yours — size ${data.size}. It's in your order history.` });
      } else {
        setClaim({ status: "error", msg: data.detail || "Claim failed. Try again." });
      }
    } catch {
      setClaim({ status: "error", msg: "Claim failed. Try again." });
    }
  };

  return (
    <>
      <Header hoverColor={pageColors.members} compact={false} />
      <div className="brand-page">
        <button className="feed-back" onClick={() => navigate("/members")} data-testid="shirt-back">
          <ArrowLeft size={16} /> Back to Members
        </button>

        <header className="brand-hero-center">
          <h1 className="shirt-title" data-testid="shirt-title">THE SHIRT</h1>
        </header>

        <section className="brand-preorder-preview" data-testid="shirt-preview">
          <div className="brand-preorder-tile">
            <img src="/img/theshirt_front.jpeg" alt="THE SHIRT — front" data-testid="shirt-front-image" />
          </div>
          <div className="brand-preorder-tile">
            <img src="/img/theshirt_back.webp" alt="THE SHIRT — back" data-testid="shirt-back-image" />
          </div>
        </section>

        <section className="brand-preorder-panel" data-testid="shirt-panel">
          <div className="brand-preorder-name">THE SHIRT</div>
          {isMember ? (
            <div className="brand-preorder-price" data-testid="shirt-price">
              <s className="shirt-price-strike">${PRICE}</s> FREE for members
            </div>
          ) : (
            <div className="brand-preorder-price" data-testid="shirt-price">${PRICE}</div>
          )}
          <div className="shirt-member-note" data-testid="shirt-member-note">
            {isMember
              ? "Members exclusive — one free shirt on the house."
              : "Members get THE SHIRT free. Sign in on the Members page if you're one of us."}
          </div>

          <div className="brand-size-block">
            <div className="brand-size-label">Size</div>
            <div className="brand-size-row" role="radiogroup" aria-label="Select size">
              {SIZES.map((s) => (
                <button
                  key={s}
                  type="button"
                  role="radio"
                  aria-checked={size === s}
                  className={`brand-size-chip${size === s ? " active" : ""}`}
                  onClick={() => setSize(s)}
                  data-testid={`shirt-size-${s}`}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          {isMember ? (
            claim.status === "ok" ? (
              <div className="shirt-claim-ok" data-testid="shirt-claim-ok">
                <Check size={18} /> {claim.msg}
              </div>
            ) : (
              <button
                type="button"
                className="btn-solid btn-huge"
                onClick={claimFree}
                disabled={claim.status === "loading"}
                data-testid="shirt-claim-btn"
              >
                <Gift size={18} />
                {claim.status === "loading" ? " Claiming…" : ` Claim free — size ${size}`}
              </button>
            )
          ) : (
            <button
              type="button"
              className="btn-solid btn-huge"
              onClick={addToCart}
              data-testid="shirt-add-btn"
            >
              {added ? (
                <>
                  <Check size={18} /> Added — size {size}
                </>
              ) : (
                <>
                  <ShoppingBag size={18} /> Add to cart — ${PRICE}
                </>
              )}
            </button>
          )}
          {claim.status === "error" && (
            <div className="cart-error" style={{ marginTop: "0.8rem" }} data-testid="shirt-claim-error">
              {claim.msg}
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default TheShirt;
